import React from 'react';

export default Object.freeze({
  serverErrorWithOutLinks: 'Произошла ошибка. Пожалуйста, повторите попытку позже.',

  // eslint-disable-next-line react/display-name
  defaultServerErrorWithId: (messageId) => (
    <p>
      Произошла ошибка № {messageId}. Пожалуйста, повторите попытку позже или{' '}
      <a href="https://www.nalog.ru/rn77/service/service_feedback/?service=51" target="_blank">
        обратитесь в службу технической поддержки
      </a>
      , указав в сообщении номер ошибки
    </p>
  ),
  defaultServerError: (
    <p>
      Произошла ошибка. Пожалуйста, повторите попытку позже или{' '}
      <a href="https://www.nalog.ru/rn77/service/service_feedback/?service=51" target="_blank">
        обратитесь в службу технической поддержки
      </a>
    </p>
  ),
  accountsAbroadSavingError: (
    <div>
      <p>
        При сохранении счета произошла ошибка. Пожалуйста, повторите попытку позже при отправке
        новых уведомлений&nbsp; и отчетов по счету или обратитесь в&nbsp;
        <a href="https://www.nalog.ru/rn77/service/service_feedback/?service=51" target="_blank">
          обратитесь в службу технической поддержки
        </a>
        .
      </p>
      <p className="green">Ваше обращение отправлено с новыми реквизитами счета.</p>
    </div>
  ),
  requiredDefaultError: 'Не заполнено обязательное поле',
  appointmentServiceError:
    'Сервис записи на приём временно недоступен. Попробуйте записаться позднее.',
  serviceIsUnavailable:
    'В настоящее время ведутся работы по улучшению Личного кабинета. Функционал данного раздела ' +
    'временно недоступен. Приносим извинения за доставленные неудобства!',
  errorLoadingData: (
    <p>
      Уважаемый пользователь!
      <br />
      В настоящее время наблюдается высокая нагрузка сервиса.
      <br />
      Просим повторить попытку позже.
      <br />
      Приносим извинения за доставленные неудобства.
    </p>
  ),
  requiredTaxAuthority: 'Не выбран налоговый орган',
  errorForbidden: <p>Функционал недоступен.</p>,
  errorForbiddenForARM: (
    <p>
      Функционал недоступен.
      <br />
      Данное действие повлечёт изменение реальных данных налогоплательщика.
    </p>
  ),
});
